'use client';

import { createContext, PropsWithChildren, useContext } from 'react';

export type TClientEnvContext = {
  NEXT_PUBLIC_RUNTIME_ENV: string;
  NEXT_PUBLIC_INSTRUCTION_URL: string;
  WB_STATIC_URL: string;
  APP_STATIC_NAMESPACE: string;
  CI_COMMIT_TAG: string;
};

const ClientEnvContext = createContext<TClientEnvContext>({
  NEXT_PUBLIC_RUNTIME_ENV: '',
  NEXT_PUBLIC_INSTRUCTION_URL: '',
  WB_STATIC_URL: '',
  APP_STATIC_NAMESPACE: '',
  CI_COMMIT_TAG: '',
});

export const ClientEnvProvider = ({
  envs,
  children,
}: PropsWithChildren<{ envs: TClientEnvContext }>) => (
  <ClientEnvContext.Provider value={envs}>{children}</ClientEnvContext.Provider>
);

ClientEnvContext.displayName = 'ClientEnvContext';

export const useClientEnvContext = () => {
  const context = useContext(ClientEnvContext);

  if (!context) {
    throw new Error(
      'useClientEnvContext must be used within a ClientEnvContext, use ClientEnvProvider',
    );
  }

  return context;
};
